import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Sparkles } from 'lucide-react';

/**
 * "What's new" trigger card that opens the WhatsNewSheet modal.
 * Extracted from Settings.jsx (line 1187-1211).
 */
export function WhatsNewCard({ language, onOpen }) {
    const isDe = language === 'de';
    return (
        <Card className="border-amber-200/40 dark:border-amber-800/30">
            <CardHeader>
                <CardTitle className="text-lg flex items-center gap-2">
                    <Sparkles className="w-5 h-5 text-amber-500" />
                    {isDe ? 'Was ist neu?' : 'What\'s new?'}
                </CardTitle>
                <CardDescription>
                    {isDe
                        ? 'Übersicht aller Funktionen, die in der letzten Version dazugekommen sind.'
                        : 'Overview of features added in the latest release.'}
                </CardDescription>
            </CardHeader>
            <CardContent>
                <Button
                    variant="outline"
                    onClick={onOpen}
                    className="w-full"
                    data-testid="open-whats-new-btn"
                >
                    <Sparkles className="w-4 h-4 mr-2" />
                    {isDe ? 'Release Notes öffnen' : 'Open release notes'}
                </Button>
            </CardContent>
        </Card>
    );
}
